import React from 'react';
import Link from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/link.svg';
import LinkGold from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/link-gold.svg';
import Icon from 'components/canvas/components/icon';
import {
  useIsLinkArrowShown,
  useNodeLinking,
  useNodeLinkingOperations,
} from 'state/canvas/node-linking';
import { useIsCanvasDraggableOperations } from 'components/canvas/hooks/use-is-canvas-draggable';
import { useIsCanvasSelectableOperations } from 'components/canvas/hooks/use-is-canvas-selectable';
import { isMobile } from 'react-device-detect';
import { SurfaceNodePointsToPosition, SurfaceNodeUnion } from 'graphql/types';
import { KonvaEventObject } from 'konva/lib/Node';

export interface LinkIconProps {
  onClick?: (event: KonvaEventObject<MouseEvent>) => void;
  node: SurfaceNodeUnion;
  width?: number;
  height?: number;
}

const defaultProps = {
  isSelected: false,
};

function LinkIcon(props: LinkIconProps) {
  const { node } = props;

  const isLinkArrowShown = useIsLinkArrowShown();

  const [isSelected, setSelected] = React.useState<boolean>(isLinkArrowShown);

  const { showLinkArrow } = useNodeLinkingOperations();

  const { setCanvasDraggable } = useIsCanvasDraggableOperations();

  const { setIsCanvasSelectable } = useIsCanvasSelectableOperations();

  function onClick(event) {
    const fromNode = {
      ...node,
      position: SurfaceNodePointsToPosition.Left,
    };

    if (isMobile) {
      setCanvasDraggable(false);
      setIsCanvasSelectable(false);
    }

    showLinkArrow(fromNode as any);

    props.onClick && props.onClick(event);
  }

  const src = isSelected || isLinkArrowShown ? LinkGold : Link;

  return (
    <Icon
      {...props}
      onClick={onClick}
      src={src}
      onMouseOver={() => setSelected(true)}
      onMouseOut={() => setSelected(false)}
    />
  );
}

LinkIcon.defaultProps = defaultProps;

export default LinkIcon;
